module.exports = __webpack_public_path__ + "img/bg_pno_intro.2897067f.jpg";